export default Object.freeze({
  None: 0,
  ByteArray: 1,
  Base64String: 2,
  ZipByteArray: 3,
  ZipBase64String: 4,
  HttpBodyBinaryData: 5,
});
